import { Hide, Image, Show } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '@/assets/goldenrush/images/logo.png';
import { THEME_NAME } from '@/constants/themeConfig';

export default function Index() {
  return (
    <Link to="/">
      <Show above="lg">
        <Image
          src={logo}
          alt={`${THEME_NAME.goldenrush}`}
          data-testid={`${THEME_NAME.goldenrush}_desktop`}
          mx="auto"
          mb="4"
          w="235px"
          h={{ base: '8', lg: 'auto' }}
          filter="drop-shadow(0px 3px 4px rgba(0, 0, 0, 0.25))"
        />
      </Show>
      <Hide above="lg">
        <Image
          minW="105px"
          src={logo}
          alt={`${THEME_NAME.goldenrush}`}
          data-testid={`${THEME_NAME.goldenrush}_mobile`}
          w="auto"
          h="12"
        />
      </Hide>
    </Link>
  );
}
